<template>
	<div>
		<div class="teacher-fund-btn">
			<button class="solid-btn" :class="{'completed' : moneyToComplete<=0}" @click="fundPopup = !fundPopup"
			        :disabled="moneyToComplete<=0"> {{fundButton}}
			</button>
		</div>
		<div class="closing_curtain" @click="clickCortine" v-show="fundPopup"></div>
		<!--Funraising Popup-->
		<div :class="fundPopupClass" v-loading="loading">

			<div class="popup-heading">
				<div class="text-right"><a class="ivu-modal-close" @click.prevent="fundPopup = false">
					<i class="ivu-icon ivu-icon-ios-close"></i></a></div>
				<h6 class="title-6" style="margin-top: 10px">How much would you like to give?</h6>
			</div>
			<div class="popup-content">
				<p class="paragraph">This classroom only needs <span>{{numberToCurrency(moneyToComplete)}}</span> to
					fully fund their Classroom Supply Box</p>
				<form style="width: 80%; margin:auto">
					<div class="select-fund">
						<input v-model="amount" type="radio" id="25" name="amount" :value="25"
						       :disabled="!disabledAmountButton(25)">
						<label for="25" disabled>&#36; 25</label>

						<input v-model="amount" type="radio" id="50" name="amount" :value="50"
						       :disabled="!disabledAmountButton(50)">
						<label class="no-margin" for="50">&#36; 50</label>

						<input v-model="amount" type="radio" id="100" name="amount" :value="100"
						       :disabled="!disabledAmountButton(100)">
						<label for="100">&#36; 100</label>


						<input v-model="amount" type="radio" :id="moneyToComplete" name="amount"
						       :value="moneyToComplete">
						<label class="no-margin" :for="moneyToComplete">{{numberToCurrency(moneyToComplete)}}</label>
					</div>
					<br>
					<money id='customAmount' class="input-field text-right"
					       v-bind="moneyConfig" v-model="amount" @click="selectCustomAmount"></money>
					<br>
					<div id="payment-form">

						<input type="number" style="display: none" name="amount" v-model="amount"><br>
						<div class="add-cart-btn">
                            <button class="solid-btn" @click.prevent="addToCart(false)">Add to cart<i class="fa fa-cart-plus" aria-hidden="true"></i></button>
                        </div>
                        <button class="solid-btn outline" @click.prevent="addToCart(true)">Checkout<i class="fa fa-chevron-right" aria-hidden="true"></i></button>
					</div>
				</form>
			</div>
		</div>
		<!--Funraising Popup-->
		<Modal title="Donation Warning"
        v-model="showDonationWarning"
		class-name="vertical-center-modal warning-modal">
			<p v-if="isWarningMaximum">
				Your donation exceeds the amount required for this funding
			</p>

			<p v-if="isWarningMinimum">
				Minimun donation amount it's ${{minDonation}}
			</p>

			<template slot="footer">
				<div class="text-center">
					<button class="solid-btn" @click="warningPopupReset()">Ok</button>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
	export default {

		mounted() {
			let vm = this;

			if(window.localStorage.getItem('cartId')!==null){
			    this.cartId = parseInt(window.localStorage.getItem('cartId'));
            }

			$('#customAmount').click(() => {
				vm.selectCustomAmount();
			});

		},
		props: {
		    fundraiser:{
		        required:true,
            },
		    fundraiserId:{
		        required:true,
            },
			goal: {
				type: Number,
				required: true,
			},
			raised: {
				type: Number,
				required: true,
			},
		},
		data() {
			return {
				amount: 0,
				minDonation:1,
				validating: false,
				fundPopup: false,
				moneyConfig: {
					decimal: '.',
					thousands: ',',
					prefix: '$ ',
					suffix: '',
					precision: 2,
					masked: false
				},
				showDonationWarning: false,
				isWarningMinimum:null,
				isWarningMaximum:null,
                cartId:null,
                loading:false,
			}
		},

		watch: {
			fundPopup() {
				this.setDefaultAmount();
			}
		},

		computed: {
			fundPopupClass() {
				return this.fundPopup ? 'fundraising-popup active' : 'fundraising-popup';
			},
			moneyToComplete() {
				return this.goal - this.raised;
			},
			// redirectRoute() {
			// 	let fundraiserId = this.$root.$refs.page.fundraiser.id;
			// 	return window.App.globalData.routes.redirectRoute.replace('ID', fundraiserId);
			// },

			fundButton() {
				return (this.moneyToComplete > 0) ? 'Fund this Teacher' : 'This Fundraiser is completed'
			},
            addItemRoute(){
                return window.App.globalData.routes.add_item_to_cart.replace('ID',this.cartId);
            },
            item(){
                return {
                    "name": this.fundraiser.teacher.name,
                    "grade": this.fundraiser.teacher.grade_taught,
                    "state": this.fundraiser.teacher.state_name,
                    "school": this.fundraiser.teacher.school,
                    "district": this.fundraiser.teacher.district,
                    "goal_amount": (App.goal_amount/100).toFixed(2),
                    "fundraiser_id": this.fundraiser.id,
                    "raised_amount": this.fundraiser.teacher.fundraiser_raised_amount,
                    "new_teacher_id": null,
                    "fundraiser_slug": this.fundraiser.teacher.fundraiser_slug,
                    "current_donation": this.amount,
                };
            }
		},

		methods: {
            createCart(goToCheckout){
                let createRoute = window.App.globalData.routes.create_cart;
                axios.post(createRoute).then(response=>{
                    this.cartId = response.data.data.cart_id;
                    kinfEvents.$emit('CartCreated',this.cartId);
                    window.localStorage.setItem('cartId',this.cartId);
                    this.addToCart(goToCheckout);
                }).catch(e=>{
                    this.loading=false;
                    this.$notify({
                        title: 'Error',
                        message: e.response.data.response.message,
                        type: 'error'
                    });
                    console.log(e)
                });
            },
		    addToCart(goToCheckout){
                this.loading=true;
		        if(!this.validate()){return;}
		        if(this.cartId===null){this.createCart(goToCheckout);return;}
                axios.post(this.addItemRoute,{
                    fundraiser_id:this.fundraiserId,
                    amount:this.amount,
                    item:this.item,
                }).then(response=>{
                    this.fundPopup=false;
                    this.loading=false;
                    this.inCart = true;
                    this.$notify({
                        title: 'Success',
                        message: response.data.response.message,
                        type: 'success'
                    });
                    this.warningPopupReset();
                    if(goToCheckout){
                        this.goToCheckout();
                    }
                }).catch(e=>{
                    this.$notify({
                        title: 'Error',
                        message: e.response.data.response.message,
                        type: 'error'
                    });
                    this.loading = false;
                    console.log(e)
                });
            },
            goToCheckout(){
                window.location = window.App.globalData.routes.checkout_page;
            },
			clickCortine(ev) {
				//console.log(ev);
				this.fundPopup = false;
				let pageX = ev.clientX;
				let pageY = ev.clientY;
				setTimeout(() => {
					document.elementFromPoint(pageX, pageY).click();
				}, 100);
			},

			openCheckout() {
				let vm = this;
				// console.log('hola mundo');
				if (this.validate()) {

				}
			},
			validate() {

				if (Math.floor(this.amount) > this.moneyToComplete) {
					this.showWarningPopup(true);
					this.amount = this.moneyToComplete;
					this.loading = false;
					return false;
				}

				if(this.amount < this.minDonation){
					this.showWarningPopup(false);
					this.amount = this.minDonation;
					this.loading = false;
					return false;
				}

				this.warningPopupReset();

				return true;
			},
			// validateEmail(mail) {
			// 	if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
			// 		return true;
			// 	}
			// 	return false
			// },
			selectCustomAmount() {
				$('#customAmount').select();
			},
			numberToCurrency(number) {
				let formatter = new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: 'USD',
					minimumFractionDigits: 2,
					// the default value for minimumFractionDigits depends on the currency
					// and is usually already 2
				});

				return formatter.format(number).replace('$', '$ ');
			},
			disabledAmountButton(num) {
				return this.moneyToComplete > num;
			},
			setDefaultAmount() {
			    if(this.amount){return;}
				let vm = this;
				let moneyToComplete = this.goal - this.raised;
				let amounts = [moneyToComplete, 25, 50, 100];
				amounts.filter((value) => {
						// console.log(value,moneyToComplete);
					if (value <= moneyToComplete) {
						vm.amount = value;
					}
				});
			},

			showWarningPopup(showForMaximum){
				this.showDonationWarning = true;
				if(showForMaximum) return this.isWarningMaximum = true;

				this.isWarningMinimum = true;
			},

			warningPopupReset(){
				this.showDonationWarning = false;
				this.isWarningMaximum = false;
				this.isWarningMinimum = false;
			}

		}
	}
</script>

<style scoped lang="less">
	.select-fund > label {
		cursor: pointer;
	}

	.text-right {
		text-align: right !important;
	}

	.fundraising-popup .popup-content .select-fund label {
		width: 49% !important;
		font-family: "Rubik-Medium" !important;
		font-size: 16px !important;
	}

	.fundraising-popup .popup-content .select-fund {
		margin-bottom: 0 !important;
	}

	.fundraising-popup .popup-content {
		padding: 20px 25px !important;
	}

	.ivu-modal-close > i.ivu-icon.ivu-icon-ios-close {
		top: 0px;
		border-radius: 100%;
		border: 1px solid #d9232e;
		width: 30px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		color: #d9232e;
		font-weight: bold;
		font-size: 21px;
		margin-bottom: 15px;
	}

	.ivu-modal-close > i.ivu-icon.ivu-icon-ios-close:hover {
		border: 1px solid #FB202D;
		color: #FB202D;

	}

	.ivu-modal-close > i.ivu-icon.ivu-icon-ios-close:active {
		border: 1px solid #BF131F;
		color: #BF131F;

	}

	.vertical-center-modal {
		display: flex;
		align-items: center;
		justify-content: center;

		.ivu-modal {
			top: 0;
		}
	}

	.warning-modal {
		p {
			font-size: 16px;
			text-align: center;
			font-family: 'Rubik-Regular';
		}
	}

	.closing_curtain {
		position: fixed;
		z-index: 8;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0);
		pointer-events: all;
	}

	.completed {
		line-height: 48px !important;
		background: #49ceb0;
	}

	.paragraph {
		margin-bottom: 10px !important;
	}

	.mb-10 {
		margin-bottom: 10px !important;
	}
</style>



// WEBPACK FOOTER //
// resources/js/views/fundraisers/components/show/Checkout.vue